import { Box, Container, Icon, Link, Stack } from "@xcorejs/ui";
import SVGInstagram from "components/Icons/32/instagram.svg";
import { InstagramPostsGrid } from "components/Instagram/InstagramPostsGrid";
import { useLayout } from "xcore";
import Richtext from "../../design-system/Richtext";

const Instagram = () => {
  const { general, instagramPosts } = useLayout();

  if (instagramPosts?.status === "Failed" || !instagramPosts?.posts) {
    return null;
  }

  return (
    <Box pt={{ _: "5rem", sm: "6rem" }} bg="black">
      <Container mb={{ _: "5rem", sm: "6rem" }} flexDirection="column">
        <Stack direction="column" gap="4rem" align="center">
          <Link variant="simple" href="https://www.instagram.com/robelighting/" target="_blank">
            <Icon svg={<SVGInstagram />} />
          </Link>

          <Box>
            <Richtext
              value={general.values.aboveFooter}
              _link={{
                variant: "underline",
                fontSize: "inherit",
                lineHeight: "inherit",
              }}
              _paragraph={{
                variant: "lead",
                textAlign: "center",
              }}
            />
          </Box>
        </Stack>
      </Container>

      <InstagramPostsGrid posts={instagramPosts?.posts.slice(0, 6)} />
    </Box>
  );
};

export default Instagram;
